import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Upload = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2932 8.29325L15.2932 5.29325C15.6842 4.90225 16.3163 4.90225 16.7073 5.29325L19.7073 8.29325C19.9023 8.48825 20.0002 8.74428 20.0002 9.00028C20.0002 9.25628 19.9023 9.51231 19.7073 9.70731C19.3163 10.0983 18.6842 10.0983 18.2932 9.70731L17.0002 8.41422L17.0003 20.0003C17.0003 20.5523 16.5523 21.0003 16.0003 21.0003C15.4483 21.0003 15.0003 20.5523 15.0003 20.0003L15.0002 8.41422L13.7073 9.70731C13.3163 10.0983 12.6842 10.0983 12.2932 9.70731C11.9022 9.31631 11.9022 8.68425 12.2932 8.29325ZM5 19V25C5 26.104 5.896 27 7 27H25C26.105 27 27 26.104 27 25V19C27 18.4478 26.5523 18 26 18C25.4477 18 25 18.4478 25 19V25H7V19C7 18.4478 6.55228 18 6 18C5.44772 18 5 18.4478 5 19Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Upload
